export const PURCHASE_HISTORY_COLUMNS = [
  { title: "ID", dataIndex: "id", key: "id" },
  { title: "Pacote", dataIndex: "package", key: "package" },
  { title: "Pagamento", dataIndex: "payment", key: "payment" },
  { title: "Data", dataIndex: "date", key: "date" },
  { title: "Consumo", dataIndex: "consumption", key: "consumption" },
  { title: "Valor", dataIndex: "value", key: "value" },
];
